import { isFunction } from '..';

export var maybeCall = function maybeCall(fn) {
  return function () {
    if (isFunction(fn)) return fn.apply(undefined, arguments);else return undefined;
  };
};